import { render, staticRenderFns } from "./ProjectSwitch.vue?vue&type=template&id=df74c980&scoped=true&"
import script from "./ProjectSwitch.vue?vue&type=script&lang=js&"
export * from "./ProjectSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSwitch.vue?vue&type=style&index=0&id=df74c980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df74c980",
  null
  
)

export default component.exports